import React from 'react'
import { components } from 'react-select'
import styled from 'styled-components'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

type Props = React.ComponentProps<typeof components.LoadingMessage>

function LoadingMessage({ children, ...props }: Props) {
  return (
    <components.LoadingMessage {...props}>
      <Wrapper>
        <BodyText variant="large" weight="bold" colour="neutral-one">Loading</BodyText>
        <LoadingIndicator visible inline opaque/>
      </Wrapper>
    </components.LoadingMessage>
  )
}

export default LoadingMessage
